// extracted by mini-css-extract-plugin
export default {"item":"productItem_item__NSX0g","image":"productItem_image__LjqQu","content":"productItem_content__bgnHZ","actions":"productItem_actions__BXzpx"};